import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, OverlayTrigger, Tab } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import RedTick from '../../../../../assets/images/module/general/RedTick.svg';
import MeterIcon from '../../../../../assets/images/module/general/blueEmptyMeter.svg';
import { Checkbox, Group, Loader, Stack, TextInput, Tooltip } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import { NumericFormat } from 'react-number-format';
import Autoload from '../../../../Autoload';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import dayjs from 'dayjs';
import accounting from 'accounting';
import MeterReadingsForMeterLineChart from '../MeterCharts/MeterReadingsForMeterLineChart';
import CloseIcon from '@material-ui/icons/Close';
import { Delete } from '@material-ui/icons';
import DeleteMeterReadingConfirmation from './DeleteMeterReadingConfirmation';
import SmokeDetectorDataHandler from '../../../../helpers/DataHandler/SmokeDetector';
import SmokeDetectorStatusBadges from '../SmokeDetector/SmokeDetectorStatusBadges';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

export class ViewMeterReadingsForMeterModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    meterReadings: [],
    meterReadingLoader: false
  };
  
  constructor(props) {
    super(props);
    dayjs.extend(utc);
    dayjs.extend(timezone);
  }

  componentDidMount(){
    this.getMeterReadingsForMeter();
  }

  getMeterReadingsForMeter=()=>{
    const {selectedMeter} = this.props;
    this.setState({meterReadingLoader: true});
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.meter_api_base_url + 'meterReadings/forMeter?meterId=' + selectedMeter.id,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleGetMeterReadingsForMeter',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleGetMeterReadingsForMeter(response){
    console.log('handleGetMeterReadingsForMeter: ', response);
    if(response.status && response.statuscode === 200){
      this.setState({meterReadings: response.result.filter((meterReading)=> meterReading.currentValue !== null)
        //.filter((meterReading)=> (dayjs(meterReading.meterReadingDate).isBefore(dayjs()) || dayjs(meterReading.meterReadingDate).isSame(dayjs())))
        .sort((a, b) => {
        const dateA = new Date(a.meterReadingDate);
        const dateB = new Date(b.meterReadingDate);
        return dateB - dateA;
      }), meterReadingLoader: false});
    }else{
      this.setState({meterReadingLoader: false});
    }
  }

  deleteMeterReading=(meterReadingId)=>{
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.meter_api_base_url + 'meterReadings/' + meterReadingId,
      'DELETE',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleDeleteMeterReading',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleDeleteMeterReading(response){
    console.log('handleDeleteMeterReading: ', response);
    if(response.status && response.statuscode === 200){
      showNotification({
        message: 'Die Ablesung wurde erfolgreich gelöscht.',
        icon: <img src={GreenTick} alt='success' style={{width: '16px'}}/>
      });
      this.getMeterReadingsForMeter();
    }else{
      showNotification({
        message: 'Die Ablesung konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
        icon: <img src={RedTick} alt='error' style={{width: '16px'}}/>
      });
    }
  }

  renderTableHeader=()=> {
    return(
      <TableHead>
        <TableRow>
          {/* <TableCell className='meter-logs-detail-meter-reading-table-header-cell'>Zählernummer</TableCell> */}
          <TableCell className='meter-logs-detail-meter-reading-table-header-cell'>Ablesezeitpunkt</TableCell>
          <TableCell className='meter-logs-detail-meter-reading-table-header-cell' style={{textAlign: 'right'}}>Wert</TableCell>
          <TableCell className='meter-logs-detail-meter-reading-table-header-cell' width={'5%'}>Einheit</TableCell>
          <TableCell className='meter-logs-detail-meter-reading-table-header-cell'/>
        </TableRow>
      </TableHead>
    )
  }

  renderTableBody=()=>{
    const {meterReadings} = this.state;
    const {selectedMeter} = this.props;
    const isSmokeDetector = SmokeDetectorDataHandler.isSmokeDetectorMeter(selectedMeter);
    console.log('meterReadings: ', meterReadings);
    return(
      <TableBody>
        {meterReadings.length > 0 ?
        meterReadings.sort((a,b)=> new Date(b.meterReadingDate) - new Date(a.meterReadingDate)).map((meterReading)=>
        <TableRow key={meterReading?.id} className='meter-logs-detail-meter-reading-table-body-row'>
          {/* <TableCell className='meter-logs-detail-meter-reading-table-body-cell'>
            {meterReading?.meter?.meterNo ? meterReading?.meter?.meterNo : '-'}
          </TableCell> */}
          <TableCell className='meter-logs-detail-meter-reading-table-body-cell'>
            {dayjs.utc(meterReading?.meterReadingDate).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('DD.MM.YYYY (HH:mm)')}
          </TableCell>
          <TableCell style={{textAlign: 'right'}} className='meter-logs-detail-meter-reading-table-body-cell'>
            {isSmokeDetector
              ? <SmokeDetectorStatusBadges decodedStatus={SmokeDetectorDataHandler.mapDetector(meterReading).decodedStatus} justify="flex-end" />
              : (meterReading?.currentValue !== null || meterReading?.currentValue !== undefined) ? accounting.formatNumber(meterReading?.currentValue, 2, '.', ',') : '-'}
          </TableCell>
          <TableCell className='meter-logs-detail-meter-reading-table-body-cell'>
            {meterReading?.meter?.allocationKey?.units ? meterReading?.meter?.allocationKey?.units : '-'}
          </TableCell>
          <TableCell className='meter-logs-detail-meter-reading-table-body-cell' width={'5%'} style={{textAlign: 'center', cursor: 'pointer'}} onClick={()=> this.setState({deleteMeterReadingConfirmationOpen: true, meterReadingToDelete: meterReading.id})}>
            <Tooltip label='Ablesung löschen' zIndex={9999999}>
              <CloseIcon style={{color: '#727293', fontSize: '16px'}} className='delete-meter-reading-icon'/>
            </Tooltip>
          </TableCell>
        </TableRow>)
        :
        <TableRow>
          <TableCell colSpan={4}>
            <EmptyStateContainer
            heading={'Keine Zählerwerte vorhanden.'}
            subheading={'Führen Sie Ablesungen durch, um Zählerwerte zu erfassen.'}
            icon={MeterIcon}
            showBtn={true}
            btnText={'Ablesung durchführen'}
            btnHandler={()=> this.props.history.push('/meter/reading')}
            styleMainContainer={{margin: '30px 0px'}}
            />
          </TableCell>
        </TableRow>}
      </TableBody>
    )
  }
  
  render() {
    const { open, toggle, className, selectedMeter } = this.props;
    const { meterReadingLoader, meterReadings, isMobile, deleteMeterReadingConfirmationOpen, meterReadingToDelete } = this.state;
    const isSmokeDetector = SmokeDetectorDataHandler.isSmokeDetectorMeter(selectedMeter);
    console.log('selectedMeter: ', selectedMeter);
    return (
      <CustomModal
        heading={`Zählerwerte`}
        headingClassName={'update-received-rent-modal-heading'}
        open={open}
        toggle={() => {
          toggle();
        }}
        className={`${className}`}
        style={{minWidth: !isMobile && '700px'}}
      >
        <Stack>
            {meterReadingLoader === false && meterReadings.length > 0 && !isSmokeDetector &&
            <Group style={{width: '100%', marginBottom: '20px'}}>
              <MeterReadingsForMeterLineChart meterReadings={meterReadings}/>
            </Group>}
            <Group>
              {meterReadingLoader ? 
              <Group style={{width: '100%', height: '350px'}} justify='center' align={'center'}>
                <Loader/>
              </Group>
              :
              <Stack style={{width: '100%'}}>
                {!isSmokeDetector && <Group><span className='add-allocation-sub-headings'>Zählerablesungen</span></Group>}
                <TableContainer style={{maxHeight: '350px'}}>
                  <Table stickyHeader>
                    {meterReadings.length > 0 && this.renderTableHeader()}
                    {this.renderTableBody()}
                  </Table>
                </TableContainer>
              </Stack>}
            </Group>
            <Group justify='right'>
                <div>
                    <ColorButton
                    text={'Schließen'}
                    className='gray-btn'
                    onClick={()=> toggle()}
                    />
                </div>
            </Group>
        </Stack>
        {deleteMeterReadingConfirmationOpen &&
        <DeleteMeterReadingConfirmation
        open={deleteMeterReadingConfirmationOpen}
        toggle={()=> this.setState({deleteMeterReadingConfirmationOpen: false, meterReadingToDelete: null})}
        deleteMeterReading={()=> {
          this.deleteMeterReading(meterReadingToDelete);
          this.setState({deleteMeterReadingConfirmationOpen: false, meterReadingToDelete: null});
        }}
        />}
      </CustomModal>
    );
  }
}

export default ViewMeterReadingsForMeterModal;
